import { render, staticRenderFns } from "./FormSuggestion.vue?vue&type=template&id=2533b839&"
import script from "./FormSuggestion.vue?vue&type=script&lang=js&"
export * from "./FormSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports